import React, { FC } from 'react';
import { styled } from 'styled-components';
import { Button } from '../buttons';
import { HelpIcon, HelpIconContainer } from '../helpIconContainer';
import { Icon } from '../icon';
import { Input } from '../input';
import { TextArea } from '../textArea';

const Caption = styled.div`
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 1.4;
    color: #78909c;
`;

const _FormControl: FC<{
    label?: React.ReactNode;
    tooltipLabelHtml?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
    iconTooltip?: React.ReactNode;
    caption?: React.ReactNode;
    horizontal?: boolean;
    interactiveTooltip?: boolean;
    onIconTooltipClick?: () => void;
}> = ({ label, tooltipLabelHtml, caption, className, children, iconTooltip, interactiveTooltip, onIconTooltipClick }) => {
    return (
        <div className={className}>
            {label && (
                <label>
                    <span>{label}</span>
                    {tooltipLabelHtml && (
                        <HelpIconContainer
                            className='form-control-help-icon'
                            onClick={onIconTooltipClick}
                            tooltip={tooltipLabelHtml}
                            interactive={interactiveTooltip}
                        >
                            {iconTooltip || <HelpIcon />}
                        </HelpIconContainer>
                    )}
                </label>
            )}

            {caption && <Caption>{caption}</Caption>}
            <div>{children}</div>
        </div>
    );
};

export const FormControl = styled(_FormControl)`
    width: 100%;

    > label {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        position: relative;
        margin-bottom: 6px;
        font-size: 14px;
        color: #263238;
        white-space: nowrap;
        line-height: 18px;

        > span {
            display: inline-flex;
            align-items: center;
        }

        > ${Icon}.form-control-help-icon {
            cursor: pointer;
            position: static;
            color: ${(props) => props.theme.app.primary};
            border-radius: 50%;
            background: rgba(244, 81, 30, 0.08);

            &:hover {
                background: rgba(244, 81, 30, 0.14);
            }
        }
    }

    &:has(${Caption}) label {
        margin-bottom: 4px;
    }

    ${Input}, ${TextArea}, ${Button} {
        width: 100%;
    }

    select {
        width: 100%;
    }

    > div {
        clear: both;
        position: relative;
    }
`;

export const FormControlInline = styled(_FormControl)`
    inline-size: max-content;
    display: inline-block;

    span {
        display: inline-block;
        font-size: 14px;
    }

    > label {
        display: block;
        margin-bottom: 20px;
    }

    ${Input}, ${TextArea}, ${Button} {
        width: 100%;
    }
`;

export const SectionControl = styled(_FormControl)`
    display: flex;
    align-items: center;
    padding: 10px 0;
    font-size: 12px;
    min-height: 60px;
    /* padding: 0 1rem 0 0.5rem; */

    label {
        margin-right: auto;
        font-size: 0.9rem;
        display: inline;
    }

    > div {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        > input {
            max-width: 90px;
        }
    }
`;

export const Level = styled.div<{
    $align?: 'flex-start' | 'center' | 'flex-end';
    $justify?: 'flex-start' | 'center' | 'flex-end';
}>`
    display: flex;
    align-items: ${(props) => props.$align || 'center'};
    justify-content: ${(props) => props.$justify || 'flex-start'};
`;
